<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-3.jpg)' }"></div>
              <img src="public/images/pages/services/banner-diseno-moldes.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <!-- <div class="box-float-image f-l" style="width: 423px;">
              <img src="public/images/pages/services/diseno-de-moldes-de-inyeccion.jpg">
            </div> -->
            <h5 class="title">Diseño de moldes de inyeccion</h5>

            <p>
              Procesos Plasticos Inyectados les ofrece el servicio de fabricacion, diseño de moldes para inyectar sus piezas de plastico. La fabricación de moldes es parte fundamental para la inyección de los plásticos ya que estos son la forma, dimensiones y textura de las piezas que vamos a fabricar, es por ello que en Procesos Plásticos el diseño de las piezas tanto como de los moldes está basado en la excelencia para ofrecer a sus clientes el máximo servicio durante el desarrollo de un producto.
            </p>

            <br />
            <p>
              Nuestros moldes están fabricados en materiales de alta calidad, certificados por nuestros proveedores, para garantizar el buen funcionamiento y la durabilidad.
            </p>

            <br />
            <p>
              Podemos partir de una idea, un boceto, piezas de muestra, prototipos, o bien, del producto ya desarrollado por el cliente. Aplicamos un análisis por computadora de moldeo y desmoldeo para asegurar que al final del proceso, el producto cumple con las especificaciones requeridas. Contamos con equipos periféricos para el ensamble de sus productos.
            </p>

            <br />
            <p>
              Fabricamos cualquier molde que sea requerido para sus proyecto.
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
